<script>
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";

  const dispatch = createEventDispatcher();

  export let type = "error";
</script>

<article class={type} role="alert" transition:fade>
  <div class="text">
    <slot />
  </div>

  <button class="close" on:click={() => dispatch("dismiss")}>
    <i class="icon-cross" />
  </button>
</article>

<style lang="scss">
  article {
    box-sizing: border-box;
    color: white;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    width: 300px;
    box-shadow: 0px 2px 8px 0px #10107A29;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-right: 14px;

    @media (max-width: 576px) {
      margin-right: 0;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
  }

  .icon-cross {
    font-size: 12px;
    cursor: pointer;
  }

  .error {
    background: #FA624B;
  }

  .success {
    background: #12C97A;
  }

  button {
    color: white;
    background: transparent;
    border: 0 none;
    padding: 0;
    margin: 0 0 0 auto;
    line-height: 1;
    font-size: 1rem;
  }
</style>
